import { Address } from '../types/Address';

function FormatGoogleMapsResponseIntoAddress(data: any) {
  const address: Address = {};

  if (data.formatted_address) address.freeformAddress = data.formatted_address;

  if (data.address_components) {
    const street = data.address_components.find(
      (c: { types: string | string[] }): boolean => c.types.includes('route'),
    );
    const number = data.address_components.find(
      (c: { types: string | string[] }): boolean =>
        c.types.includes('street_number'),
    );
    const neighbourhood = data.address_components.find(
      (c: { types: string | string[] }): boolean =>
        c.types.includes('sublocality_level_1'),
    );
    const state = data.address_components.find(
      (c: { types: string | string[] }): boolean =>
        c.types.includes('administrative_area_level_1'),
    );
    const city = data.address_components.find(
      (c: { types: string | string[] }): boolean =>
        c.types.includes('administrative_area_level_2'),
    );

    if (street) address.street = street.long_name;
    if (number) address.number = number.long_name;
    if (neighbourhood) address.neighbourhood = neighbourhood.long_name;
    if (state) address.state = state.short_name;
    if (city) address.city = city.long_name;
  }

  address.country = 'BR';
  address.location = {
    latitude: data.geometry.location.lat(),
    longitude: data.geometry.location.lng(),
  };

  return address;
}

export { FormatGoogleMapsResponseIntoAddress };
